import { create } from 'zustand';

export type NotificationKind = 'success' | 'warning' | 'error' | 'info';

export interface AppNotification {
  id: string;
  kind: NotificationKind;
  title: string;
  description?: string;
  ts: number;
  read: boolean;
  link?: string;
}

interface RealtimeNotificationsStore {
  items: AppNotification[];
  add: (n: Omit<AppNotification, 'id' | 'ts' | 'read'>) => AppNotification;
  markAllRead: () => void;
  clear: () => void;
  unreadCount: () => number;
}

const MAX_KEEP = 50;

/**
 * In-memory store of real-time app notifications surfaced via Sonner toasts.
 * Keeps the last {@link MAX_KEEP} entries; the TopHeader bell shows the 5
 * most recent and an unread badge.
 */
export const useRealtimeNotificationsStore = create<RealtimeNotificationsStore>((set, get) => ({
  items: [],
  add: (n) => {
    const entry: AppNotification = {
      id: `ntf-${Date.now()}-${Math.random().toString(36).slice(2, 8)}`,
      ts: Date.now(),
      read: false,
      ...n,
    };
    set((s) => ({ items: [entry, ...s.items].slice(0, MAX_KEEP) }));
    return entry;
  },
  markAllRead: () => set((s) => ({ items: s.items.map((i) => ({ ...i, read: true })) })),
  clear: () => set({ items: [] }),
  unreadCount: () => get().items.filter((i) => !i.read).length,
}));
